<template>

  <card-item card="item_client" :tabs="tabs" :activeTab="activeTab" :id="id" :infoKeys="infoKeys"/>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key:'information_card',
          component: () => import("./Info"),
        },
        {
          key:'groups_card',
          title: "Группы",
          component: () => import("./ClientGroup"),
        },
        {
               key:'guardians_card',
          title: "Родители",
          component: () => import("./ClientGuardian"),
        },
        {
            key:'change_password',
          title: "Сменить пароль",
          component: () => import("./Password"),
        },
      ],
      activeTab: 0,
           infoKeys:[
        {
          key: 'id',
          title:'ID'
        },
        {
          key: 'full_name',
          title:'Ученик'
        },
        {
          key: 'phone',
          title:'Номер телефона'
        },
        ]
    };
  },
};
</script>